import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MessageService } from './message.service';
import { StateService } from './state.service';
import { State } from '../enums/state.enum';
import { map, takeUntil } from 'rxjs/operators';
import { SocketConnectionService } from './socket-connection.service';
import { TypingEventService } from 'app/chat/interaction/services/typing-event.service';
import { LocalStorage } from '../enums/local-storage.enum';

@Injectable()
export class UnreadMessageService {
  unreadMessages$ = new BehaviorSubject<number>(this.getInitialValue());
  state: State;

  destroy$ = new Subject<void>();

  constructor(private stateService: StateService) {
    this.stateService
      .getState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.state = state;
      });

    this.unreadMessages$.subscribe((res) => {
      localStorage.setItem(
        LocalStorage.LOGATE_CHAT_UNREAD_MESSAGES,
        res.toString()
      );
    });
  }

  incrementUnreadMessages() {
    this.unreadMessages$.next(this.unreadMessages$.getValue() + 1);
  }

  getInitialValue() {
    if (localStorage.getItem(LocalStorage.LOGATE_CHAT_UNREAD_MESSAGES)) {
      return +localStorage.getItem(LocalStorage.LOGATE_CHAT_UNREAD_MESSAGES);
    } else return 0;
  }

  destroyService() {
    this.unreadMessages$.next(0);
    this.state = undefined;
    this.destroy$.next();
    this.destroy$.complete();
  }
}
